// extracted by mini-css-extract-plugin
export default {"credentialForm":"SwifterForm_credentialForm__pr3gJ","credentialActions":"SwifterForm_credentialActions__9bP3l"};